import useIsMobile from "../../hooks/useIsMobile";
import { isBLSDomain } from "../BLSMobileGate/BLSMobileGate";

const MobileViewSwap = ({ desktop, mobile }) => {
  const isMobile = useIsMobile();
  if (!isBLSDomain()) return desktop;
  return isMobile ? mobile : desktop;
};

export default MobileViewSwap;
